export default "__VITE_ASSET__14a3d73c__"